import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { ContentTypeValues, DefaultNewImages } from 'src/app/common/constant/constant';
import { PerfectScrollbarConfigInterface } from "ngx-perfect-scrollbar";
import { ApiService } from 'src/app/services/api/api.service';
import { Constant } from 'src/app/common/constant/constant';
import { RoEstimationComponent } from 'src/app/components/common/ro-estimation/ro-estimation.component';
import { RoInvoiceComponent } from 'src/app/components/common/ro-invoice/ro-invoice.component';
import * as moment from 'moment';
import * as momentTimeZone from 'moment-timezone';

@Component({
  selector: 'app-ro-estimate-list',
  templateUrl: './ro-estimate-list.component.html',
  styleUrls: ['./ro-estimate-list.component.scss']
})
export class RoEstimateListComponent implements OnInit {
  estimationRef: RoEstimationComponent;
  roInvoiceRef: RoInvoiceComponent;
  @Input() iscanDomain: boolean = false;
  @Input() endUser: boolean = false;
  @Input() roData: any = [];
  @Input() estimateInfo: any = [];
  @Input() section: string = "estimation";  
  @Input() roId: any = 0;
  @Output() estimateCallback: EventEmitter<any> = new EventEmitter();
  @Output() estimateListCallback: EventEmitter<RoEstimateListComponent> = new EventEmitter();
  @Output() payAfterCallback: EventEmitter<RoEstimateListComponent> = new EventEmitter();  
  @Output() roEstimateListApprove: EventEmitter<RoEstimateListComponent> = new EventEmitter();  
  public sconfig: PerfectScrollbarConfigInterface = {};
  public estimateActionType = 'retail';
  public retailText: string = "Retail";
  public viewType: string = "estimate";
  public wdText: string = "";
  public baseV3ApiUrl: string = "";
  public supportTicketPath: string = "support-tickets";
  public previewUrl: string = "";
  public innerHeight: any = 600;
  public pTableHeight = '280px';
  public estimationListColumns: any = [];
  public roStatus: any = 0;
  public estimateList: any = [];
  public estimateTotal: any = 0;
  public estimateCount: any = 0;
  public invoiceCount: any = 0;
  public paymentCount: any = 0;
  public invoicedInt: any = 0;
  public paymentData: any = [];
  public estimateData: any = [];
  public estimateHistory: any = [];
  public invoiceData: any = [];
  public invoiceHistory: any = [];
  public isManualEst: any = 0;
  public isEstimateApprove: any = 0;
  public stripeInfo: any = [];
  public zeroVal: number = 0;
  public taxValue: any = "6";
  public adasReportId: any = 0;
  public adasThirdPartyReportId: any = 0;
  public adasReportChecked: boolean = false; 
  public contentType: any = ContentTypeValues.RepairOrder;
  public shortTitle: string = "RO";
  public access: string = "estimate-list";
  public pageTitleText: string = "Estimation";
  public estimateSubmit: boolean = false;
  public invoiceSubmit: boolean = false;
  public diagnationDomain: boolean = false;
  public contentTypeDefaultNewTextDisabled: boolean = false;
  public displayNoRecordsDefault: boolean = false;
  public displayNoRecordsShow = 6;
  public emptyContentType: string = "";
  public emptyContentImg: string = "";
  public estimateItemEmpty: boolean = false;
  public estimateContentImg = DefaultNewImages.ROEstimate;
  public estimateContentType: string = "Estimate not available";
  public invoiceItemEmpty: boolean = false;
  public invoiceContentImg = DefaultNewImages.ROInvoice;
  public invoiceContentType: string = "Invoice not available";
  public receiptItemEmpty: boolean = false;
  public receiptContentImg = DefaultNewImages.ROReceipt;
  public receiptContentType: string = "Receipt not available";
  public cardItemEmpty: boolean = false;
  public cardContentImg = DefaultNewImages.ROCard;
  public cardContentType: string = "Card details not available";
  public estimateText: string = "";
  public invoiceText: string = "";
  public contactName: any = "";
  public businessAddress: any = "";
  public businessName: any = "";
  public iscanNumber: any = "";
  public displayModal: boolean = false;
  public estimateDisplayModal: boolean = false;
  public logo: string = "";
  public estNotes: string = "";
  public invoiceNotes: string = "";
  public domainInfo: any = [];
  public salesInfo: any = [];
  public threadCategoryTile: string = "Vehicle";
  public threadCategoryImage: string = "assets/images";
  public threadCategory: any = 0;
  public viewFlag: boolean = false;
  public checkViewFlag: boolean = false;
  public estimateActionFlag: boolean = false;
  public estimatePreviewFlag: boolean = true;
  public invoiceActionFlag: boolean = false;
  public generateInvoiceSubmitFlag: boolean = false;
  public multipleEmail: string[] = [];
  public shareEmailFlag: boolean = false;
  public serverError: boolean = false;
  public serverErrorMsg: string = '';  
  public copiedModal: boolean = false;
  public estDate: string = "";
  public estVersion: any = '';
  public estimateId: number = 0;
  public invoiceDate: string = "";
  public invoiceVersion: any = '';
  public invoiceId: number = 0;
  public contactEmail: any = [];
  public currentDate: any;
  public currentDateTime: any;
  public templateInfo: any = {};
  public paymentMethodEnabledFlag: boolean = localStorage.getItem('paymentMethodEnabled') == '1' ? true : false;
  public roInvoicePreview: boolean = false;
  public maskEmail: string = Constant.maskEmail;
  public paymentMethodPreviewFlag: boolean = false;
  public invoiceTemplateFlag: boolean = false;
  
  constructor(
    private apiUrl: ApiService
  ) { }

  ngOnInit(): void {
    this.innerHeight = window.innerHeight - 100;
    this.logo = localStorage.getItem('blogo');
    let businessInfo = JSON.parse(localStorage.getItem('user'));
    let businessData = businessInfo.data;
    let domainUrl = `https://${businessData.subDomainUrl}.collabtic.com`;
    let domainInfo = [{logo: businessData.business_logo, domainName: businessData.business_name, address: '', phone: '', domainUrl, email: ''}];
    this.threadCategory = (this.roData.threadCategoryInt && this.roData.threadCategoryInt != undefined) ? this.roData.threadCategoryInt : this.threadCategory;
    this.adasReportId = (this.roData.adasReportIdInt && this.roData.adasReportIdInt != undefined) ? this.roData.adasReportIdInt : 0;
    this.adasThirdPartyReportId = (this.roData.adasThirdPartyIdInt && this.roData.adasThirdPartyIdInt != undefined) ? this.roData.adasThirdPartyIdInt: 0;
    this.setupAdasReportCheckBox();    
    let domainId:any = localStorage.getItem('domainId');
    this.retailText = (domainId == 432 || domainId == 63) ? 'List Price' : 'Retail';
    this.wdText = (domainId == 432 || domainId == 63) ? 'Cost' : 'WD';
    this.paymentMethodEnabledFlag = this.paymentMethodEnabledFlag ? true : false;    
    this.baseV3ApiUrl = this.apiUrl.apiCollabticV3BaseUrl();
    console.log(this.threadCategory)
    switch(this.threadCategory) {
      case 1:
        this.threadCategoryTile = 'Vehicle';
        this.threadCategoryImage = `${this.threadCategoryImage}/repair-order/vehicle-info.svg`;
        break;
      case 2:
        this.threadCategoryTile = 'Scan Tool';
        this.threadCategoryImage = `${this.threadCategoryImage}/common/scan-tool-icon.svg`;
        break;
      case 7:
        this.threadCategoryTile = 'General';
        this.threadCategoryImage = `${this.threadCategoryImage}/thread/tc-general-normal.svg`;
        break;
      case 10:
        this.threadCategoryTile = 'Part';
        this.threadCategoryImage = `${this.threadCategoryImage}/thread/tc-part-normal.svg`;
        break;
    }
    let currentDate = new Date();
    currentDate = moment.utc(currentDate).toDate(); 
    this.currentDate = moment(currentDate).local().format('X');
    this.currentDateTime = moment(currentDate).format('MMM DD, YYYY h:mm A');
    this.estDate = this.currentDateTime;
    this.templateInfo.estDate = this.estDate;
    this.templateInfo.paidStatus = '';
    this.templateInfo.invoiceType = '';
    this.templateInfo.paymentMethodFlag = false;
    let getParams:any = localStorage.getItem('param');
    getParams = (getParams && getParams != 'undefined') ? JSON.parse(getParams) : '';
    if(getParams != '') {
      let contItems = getParams.items;
      let cindex = contItems.findIndex(option => option.contentTypeId == this.contentType);
      if(cindex >= 0) {
        let title = contItems[cindex].name;
        this.shortTitle = title.split(' ').map(x => x[0]).join('');
      }
    }
    console.log(businessInfo.data)
    this.estimateData = [];
    this.invoiceData = [];
    this.estimationListColumns = [
      {field: 'id', columnName: 'id', header: 'Job', headerId: "1", inputType: "1", columnpredefind: "1", columnpclass: 'header ro-ta-col-1 col-sticky'},
      {field: 'jobcode', columnName: 'jobcode', header: 'Job Code', headerId: "2", columnpredefind: "1", inputType: "2", columnpclass: 'header ro-ta-col-2'},
      {field: 'jobtitle', columnName: 'jobtitle', header: 'Job Title', headerId: "3", columnpredefind: "1", inputType: "3", columnpclass: 'header ro-ta-col-3'},
      {field: 'jobdesc', columnName: 'jobdesc', header: 'Job Description', headerId: "4", columnpredefind: "1", inputType: "4", columnpclass: 'header ro-ta-col-4'},
      {field: 'jobprice', columnName: 'jobprice', header: 'Unit Price', headerId: "5", columnpredefind: "1", inputType: "5", columnpclass: 'header ro-ta-col-5'},
      {field: 'jobqty', columnName: 'jobqty', header: 'Qty', headerId: "6", inputType: "5", columnpredefind: "1", columnpclass: 'header ro-ta-col-6'},
      {field: 'jobtotal', columnName: 'jobtotal', header: 'Total', headerId: "7", inputType: "7", columnpredefind: "1", columnpclass: 'header ro-ta-col-7'},
    ];
    console.log(this.estimateInfo, this.roData)
    let address = (this.roData.businessInfo.addressLine1 != null && this.roData.businessInfo.addressLine1 != '') ? this.roData.businessInfo.addressLine1 : '';
    address = (address && (this.roData.businessInfo.addressLine2 != null && this.roData.businessInfo.addressLine2 != '')) ? `${address}, ${this.roData.businessInfo.addressLine2}` : address;
    address = (address && (this.roData.businessInfo.city != null && this.roData.businessInfo.city != '')) ? `${address} <br> ${this.roData.businessInfo.city}` : address;
    address = (address && (this.roData.businessInfo.state != null && this.roData.businessInfo.state != '')) ? `${address}, ${this.roData.businessInfo.state}` : address;
    address = (address && (this.roData.businessInfo.zip != null && this.roData.businessInfo.zip != '')) ? `${address} ${this.roData.businessInfo.zip}` : address;
    let customerEmail = (this.roData.businessInfo.email != null && this.roData.businessInfo.email != '' && this.roData.businessInfo.email != undefined) ? this.roData.businessInfo.email : ''; 
    this.businessAddress = (address != '') ? address : '';
    this.domainInfo = (this.roData.domainInfoJsonArr && this.roData.domainInfoJsonArr != undefined) ? this.roData.domainInfoJsonArr[0] : domainInfo[0];
    this.salesInfo = (this.roData.salesPersonInfoJsonArr && this.roData.salesPersonInfoJsonArr != undefined) ? this.roData.salesPersonInfoJsonArr : [];
    let access = (this.roData.access && this.roData.access != undefined) ? this.roData.access : 'est-view';
    this.roData['access'] = access;
    this.invoicedInt = (this.roData.invoicedInt && this.roData.invoicedInt != undefined) ? this.roData.invoicedInt : this.invoicedInt;
    this.estimateCount = this.estimateInfo.estimateCount;
    this.estimateData = this.estimateInfo.estimateData;
    if(!this.endUser || !this.diagnationDomain) {
      this.roData.estimationData = this.estimateData;
    }
    this.invoiceData = this.estimateInfo.invoiceData;
    this.roData.invoiceData = this.invoiceData;
    this.estimateHistory = this.estimateInfo.estimateHistory;
    this.invoiceHistory = this.estimateInfo.invoiceHistory;
    this.isManualEst = this.estimateInfo.isManualEst;
    this.isEstimateApprove = this.estimateInfo.isEstimateApprove;
    this.stripeInfo = this.estimateInfo.stripeInfo;
    this.roStatus = this.roData.workOrderStatusStr;
    this.iscanNumber = this.roData.iscanSerialNumberStr;
    this.contactName = this.roData.contactDetailInfo[0].name;
    this.invoiceCount = this.estimateInfo.invoiceCount;
    this.paymentCount = this.estimateInfo.paymentCount;
    this.invoiceId = (this.roData.invoicedInt && this.roData.invoicedInt != undefined) ? this.roData.invoicedInt : 0;
    this.paymentData = (this.paymentCount > 0) ? this.estimateInfo.paymentData : this.paymentData;
    if(this.estimateCount > 0) {
      this.estVersion = (this.estimateHistory && this.estimateHistory != undefined && this.estimateHistory.length > 0) ? this.estimateHistory[0].version : "V 0";      
      this.templateInfo.estVersion = this.estVersion;
    }
    if(this.invoiceId > 0) {
      this.invoiceVersion = (this.invoiceHistory && this.invoiceHistory != undefined && this.invoiceHistory.length > 0) ? this.invoiceHistory[0].version : "V 0";      
      this.templateInfo.invoiceVersion = this.invoiceVersion;
    }
    if(this.paymentCount > 0) {
      let transactionDate = moment.utc(this.paymentData.transactionDate).toDate(); 
      this.paymentData.transactionDate = moment(transactionDate).local().format('MMM DD, YYYY h:mm A');
      console.log(moment(transactionDate).local().format('MMM DD, YYYY h:mm A'))
    }
    console.log(this.estimateData)
    this.estimateText = (this.estimateHistory.length == 0) ? 'Send' : 'Resend';
    this.invoiceText = (this.invoiceHistory.length == 0) ? 'Send' : 'Resend';
    //this.estimateItemEmpty = (Array.isArray(this.estimateData) && this.estimateData.length == 0) ? true : false;  
    this.estimateItemEmpty = (this.estimateCount == 0) ? true : false;  
    this.cardItemEmpty = (Array.isArray(this.stripeInfo) && this.stripeInfo.length == 0) ? true : false;
    //this.invoiceItemEmpty = (this.estimateCount == 0 || (this.estimateCount > 0 && this.roStatus != 7 && this.roStatus != 12 && this.roStatus != 13 && this.roStatus != 14)) ? true : false;
    this.invoiceItemEmpty = (this.estimateCount == 0) ? true : false;
    this.receiptItemEmpty = (Array.isArray(this.paymentData) && this.paymentData.length == 0) ? true : false;
    let sectionAccess = '';
    let estFlag = false;
    let invFlag = false;
    switch(this.section) {
      case 'estimation':
      case 'manage-estimation':  
        sectionAccess = 'Estimate';
        this.viewType = 'estimate';
        estFlag = true;
        if(this.estimateItemEmpty) {
          this.emptyContentType = this.estimateContentType;
          this.emptyContentImg = this.estimateContentImg;      
        }
        this.estimateId = (this.estimateCount > 0) ? this.estimateData[0].estId : 0;
        this.estNotes = (this.estimateCount > 0 && this.estimateData[0].notes && this.estimateData[0].notes != undefined) ? this.estimateData[0].notes : '';
        this.templateInfo.estNotes = this.estNotes;
        this.estimateActionFlag = (!this.endUser && this.roData.isCustomerActiveInt == 1) ? true : false;
        let contactInfo = this.roData.contactDetailInfoJsonArr;
        contactInfo.forEach(citem => {
          let cmail = citem.email;
          let splitEmail = cmail.split(this.maskEmail);
          cmail = (splitEmail.length > 1) ? '' : cmail;
          if(cmail != '') {
            this.contactEmail.push(cmail);          
            this.addedEmail(cmail, 'manual');
          }
        });
        if(this.multipleEmail.length == 0) {
          let splitCustomerEmail = customerEmail.split(this.maskEmail);
          let custEmail = (splitCustomerEmail.length > 1) ? '' : customerEmail;
          if(custEmail != '') {
            this.addedEmail(custEmail, 'manual');
          }
        }
        break;
      case 'card':
        if(this.cardItemEmpty) {
          this.emptyContentType = this.cardContentType;
          this.emptyContentImg = this.cardContentImg;
        }
        break;  
      case 'invoice':
      case 'manage-invoice':  
        invFlag = true;
        sectionAccess = 'Invoice';
        this.viewType = 'invoice';
        if(this.invoiceItemEmpty) {
          this.emptyContentType = this.invoiceContentType;
          this.emptyContentImg = this.invoiceContentImg;
        } else {
          let estimateInfoData = this.roData.invoiceInfoDataJsonArr;
          //let isRetail = estimateInfoData[0].isRetail;
          //this.estimateActionType = (isRetail == 1) ? 'retail' : 'wd';
          this.invoiceNotes = (estimateInfoData.length > 0 && estimateInfoData[0].notes && estimateInfoData[0].notes != undefined) ? estimateInfoData[0].notes : '';
          this.templateInfo.invoiceNotes = this.invoiceNotes;
          //this.invoiceId = (this.invoiceData.length > 0) ? this.invoiceData[0].estId : 0;
          //this.roData.invoiceData = this.invoiceData;
          if(this.invoiceHistory.length > 0) {
            this.invoiceId = this.invoiceHistory[0].estId;
            this.invoiceNotes = (this.invoiceHistory[0].estNotes != '') ? this.invoiceHistory[0].estNotes : this.invoiceNotes;
            this.templateInfo.invoiceNotes = this.invoiceNotes;
            this.templateInfo.invoiceVersion = this.invoiceVersion;
          }          
          this.estimateActionFlag = (!this.endUser && this.roData.isCustomerActiveInt == 1) ? true : false;
          let contactInfo = this.roData.contactDetailInfoJsonArr;
          contactInfo.forEach(citem => {
            let cmail = citem.email;
            let splitEmail = cmail.split(this.maskEmail);
            cmail = (splitEmail.length > 1) ? '' : cmail;
            if(cmail != '') {
              this.contactEmail.push(cmail);          
              this.addedEmail(cmail, 'manual');
            }
          });
          if(this.multipleEmail.length == 0) {
            let splitCustomerEmail = customerEmail.split(this.maskEmail);
            let custEmail = (splitCustomerEmail.length > 1) ? '' : customerEmail;
            if(custEmail != '') {
              this.addedEmail(custEmail, 'manual');
            }
          }
        }
             
        break;  
      case 'receipt':
        if(this.receiptItemEmpty) {
          this.templateInfo.access = 'Receipt';
          this.emptyContentType = this.receiptContentType;
          this.emptyContentImg = this.receiptContentImg;
        }
        break;  
    }
    
    console.log(this.section, this.emptyContentType, this.emptyContentImg)

    if(estFlag && !this.estimateItemEmpty) {
      console.log(this.estimateInfo)
      let estList = (this.estimateCount > 0) ? this.estimateData[0].estimateData : this.estimateData.estimationArray;
      this.estimateList = (estList && estList != undefined) ? estList : this.estimateData;
      this.roData.estimationData = this.estimateList;
      this.estimateInfo.estimateCount += 1;
      this.estimateCount = this.estimateInfo.estimateCount;
      this.estimateItemEmpty = false;
      if(this.estimateCount > 0) {
        this.isEstimateApprove = (this.estimateData[0].isApprove == 1) ? true : false;
      }
      let estimateTotal = 0;
      console.log(this.estimateList);
      if(this.estimateList) {
        this.estimateList.forEach(item => {
          item.jobqtyShowStr = Number(item.jobqty).toFixed(2); 
          item.jobpriceShowStr = Number(item.jobprice).toFixed(2); 
          item.jobpriceShowOnly = Math.abs(item.jobprice).toFixed(2);
          item.jobtotalShowStr = Number(item.jobtotal).toFixed(2); 
          item.jobtotalShowOnly = Math.abs(item.jobtotal).toFixed(2);
          estimateTotal += parseFloat(item.jobtotal);
        });
      }
      this.estimateTotal = Math.abs(estimateTotal).toFixed(2);
      this.estimateHistory.forEach((hitem, hindex) => {
        let estDate = hitem.estDate;
        estDate = moment.utc(estDate).toDate(); 
        hitem.estDate = moment(estDate).local().format('MMM DD, YYYY h:mm A');
        if(hindex == 0) {
          this.estDate = hitem.estDate;
          this.templateInfo.estDate = this.estDate;
        }
      });
    }
    if(invFlag && !this.invoiceItemEmpty) {
      console.log(this.invoiceData, this.estimateCount)
      let estData = (this.invoiceData[0]?.estimateData && this.invoiceData[0]?.estimateData != undefined) ? this.invoiceData[0]?.estimateData : this.invoiceData[0]?.estimationArray; 
      this.estimateList = (estData && estData != undefined) ? estData : this.invoiceData;
      //this.estimateList = (this.estimateCount > 0) ? estData : this.invoiceData.estimationArray;
      this.roData.invoiceData = this.estimateList;
      this.estimateInfo.invoiceCount += 1;
      this.invoiceItemEmpty = false;
      if(this.estimateCount > 0) {
        this.isEstimateApprove = (this.estimateData[0].isApprove == 1) ? true : false;
      }
      let estimateTotal = 0;
      console.log(this.estimateList);
      if(this.estimateList) {
        this.estimateList.forEach(item => {
          item.jobqtyShowStr = Number(item.jobqty).toFixed(2); 
          item.jobpriceShowStr = Number(item.jobprice).toFixed(2); 
          item.jobpriceShowOnly = Math.abs(item.jobprice).toFixed(2);
          item.jobtotalShowStr = Number(item.jobtotal).toFixed(2); 
          item.jobtotalShowOnly = Math.abs(item.jobtotal).toFixed(2);
          estimateTotal += parseFloat(item.jobtotal);
        });
      }
      this.estimateTotal = Math.abs(estimateTotal).toFixed(2);
      this.invoiceHistory.forEach((hitem, hindex) => {
        let invoiceDate = hitem.estDate;
        invoiceDate = moment.utc(invoiceDate).toDate(); 
        hitem.invoiceDate = moment(invoiceDate).local().format('MMM DD, YYYY h:mm A');
        if(hindex == 0) {
          this.invoiceDate = hitem.estDate;
          this.templateInfo.invoiceDate = this.invoiceDate;
        }
      });
    }
    if(this.roData.invoiceInfoDataJsonArr && this.roData.invoiceInfoDataJsonArr.length>0){
      this.roData.invoiceInfoDataJsonArr.forEach((hitem, hindex) => {
        let invoiceDate = hitem.createdOn;
        invoiceDate = moment.utc(invoiceDate).toDate(); 
        invoiceDate = moment(invoiceDate).local().format('MMM DD, YYYY h:mm A');
        if(hindex == 0) {
          this.invoiceDate = invoiceDate;
          this.templateInfo.invoiceDate = this.invoiceDate;
        }
      });
    }
    this.templateInfo = {
      access: sectionAccess,
      action: '',
      paidStatus: '',
      invoiceType:'',
      paymentMethodFlag: false,
      roData: this.roData,
      domainInfo: this.domainInfo,
      salesInfo: this.salesInfo,
      businessAddress: this.businessAddress,
      threadCategoryImage: this.threadCategoryImage,
      threadCategoryTile: this.threadCategoryTile,
      threadCategory: this.threadCategory,
      estDate: this.estDate,
      estVersion: this.estVersion,
      estNotes: this.estNotes,
      invoiceDate: this.invoiceDate,
      invoiceVersion: this.invoiceVersion,
      invoiceNotes: this.invoiceNotes,
      shortTitle: this.shortTitle,
      diagnationDomain: this.diagnationDomain,
      roStatus: this.roStatus
    };
    setTimeout(() => {
      this.checkViewFlag = true;
      this.estimateListCallback.emit(this);
    }, 500);

    setTimeout(() => {
      if(this.paymentMethodEnabledFlag){
        this.loadROInvoice();
      }   
    }, 1000);
  }

  sendEstimate() {
    console.log(this.estimateData, this.estimateCount)
    let estId = (this.estimateCount > 0) ? this.estimateData[0].estId : 0;
    estId = (estId && estId != undefined) ? estId : this.estimateId;
    this.estimateSubmit = true;
    let isRetail = (this.estimateActionType == 'wd') ? 0 : 1;
    this.roData.estimationData.wdestimationTotal = this.estimationRef.wdTotalInvoice;
    let action = 'estimate';
    if(this.section == 'manage-estimation') {
      action = (this.estimateCount == 0) ? 'est-send' : 'est-resend';
    }
    let isAdasReport = ((this.adasReportId > 0 || this.adasThirdPartyReportId > 0) && this.adasReportChecked) ? 1 : 0;
    let emitData = {
      action,
      estId,
      estNotes: this.estNotes,
      sendTo: this.multipleEmail,
      roData: this.roData,
      estimateData: this.estimateData,
      wdTotalInvoice: this.estimationRef.wdTotalInvoice,
      isRetail,
      isAdasReport
    }
    this.estimateCallback.emit(emitData);
    setTimeout(() => {
      this.estimateText = 'Resend';
      this.estimateSubmit = false;
    }, 750);
  }

  sendInvoice(action) {
    setTimeout(() => {
      console.log(this.invoiceData)
      let estId = this.invoiceData[0].estId;
      estId = (estId && estId != undefined) ? estId : this.estimateInfo.estimateId;
      let isRetail = (this.estimateActionType == 'wd') ? 0 : 1;
      let isAdasReport = ((this.adasReportId > 0 || this.adasThirdPartyReportId > 0) && this.adasReportChecked) ? 1 : 0;
      this.invoiceSubmit = true;
      let emitData = {
        action,
        estId,
        isRetail,
        isAdasReport,
        invoiceNotes: this.invoiceNotes,
        sendTo: this.multipleEmail
      }
      console.log(emitData);
      this.estimateCallback.emit(emitData);
      setTimeout(() => {
        this.invoiceSubmit = false;
        this.invoiceCount += 1;
        this.invoiceText = 'Resend';
      }, 750);  
    }, 50);    
  }

  invoiceAction(action) {
    let estPreviewData = {
      action: 'preview-open'
    };
    let estPath = 'estimate-pdf';
    let previewUrl = `${this.baseV3ApiUrl}/${this.supportTicketPath}/${estPath}?id=${this.roId}&eid=`;
    switch(action) {
      case 'est-preview':
        this.templateInfo.access = 'Estimate';
        this.templateInfo.action = 'preview';
        this.estimateDisplayModal = true;
        this.previewUrl = `${previewUrl}${this.estimateId}`;
        this.estimateCallback.emit(estPreviewData);
        setTimeout(() => {
          setTimeout(() => {
            this.estimationRef.attachmentLoading = true;  
          }, 100);
          //this.estimationRef.setupJobViewHeight();
        }, 500);
        break;
      case 'preview':
        this.templateInfo.access = 'Invoice';
        this.templateInfo.action = 'preview';
        let prevAccess = 'invoice-preview';
        this.displayModal = true;
        this.invoiceTemplateFlag = false;
        this.invoiceTemplateFlag = true;
        let invoiceId = this.invoiceData[0].estId;
        this.previewUrl = `${previewUrl}${invoiceId}&access=${prevAccess}`;
        this.estimateCallback.emit(estPreviewData);
        setTimeout(() => {
          setTimeout(() => {
            this.estimationRef.attachmentLoading = true;  
          }, 100);
          //this.estimationRef.setupJobViewHeight();
        }, 500);
        setTimeout(() => {
         this.paymentMethodPreviewFlag = true;
        }, 100);
        break;
      case 'invoice':
        action = (this.invoiceHistory.length == 0) ? 'send-invoice' : 'resend-invoice';        
        this.sendInvoice(action);
        break;
      case 'generate-invoice':  
        if(!this.generateInvoiceSubmitFlag) {
          console.log(this.roData)
          let estData = this.roData.estimationData;
          let field = 'invoice';
          let fieldValue = JSON.stringify(estData);
          this.generateInvoiceSubmitFlag = true;
          this.estimateAction(field, fieldValue, estData, true);
        }
        break;  
    }
  }

  estimateAction(field, fieldValue, estData: any = [], isGenerateInvoice = false) {
    console.log(fieldValue)
    let estId = this.estimateId;
    let emitData = {
      action: 'update',
      field,
      fieldValue,
      estId,
      estData,
      estNotes: (field == 'invoiceNotes') ? this.estNotes : this.invoiceNotes,
      roData: this.roData,
      isGenerateInvoice 
    }
    this.estimateCallback.emit(emitData);
  } 

  addedEmail(value, action='') {
    console.log(this.multipleEmail);
    if(value != undefined){
      if(value.length>0){
        this.shareEmailFlag = true;
        this.serverErrorMsg = '';
        this.serverError = false;      
        if(!this.validateEmail(value)) {
          this.shareEmailFlag = false;
          this.serverError = true;
          this.serverErrorMsg = value + ' is not a valid mail address';
          //this.multipleEmail.pop();  
        } else {
          if(action == 'manual') {
            this.multipleEmail.push(value);  
          }
        }
      }
      else{
        this.shareEmailFlag = false;
      }
    }
  }

  removedEmail(event){
    console.log(event)
    this.serverErrorMsg = '';
    this.serverError = false;
    console.log(this.multipleEmail);
  
    if(this.multipleEmail != undefined){
      if(this.multipleEmail.length>0){
        this.shareEmailFlag = true;
      }
      else{
        this.shareEmailFlag = false;
      }
    }
  }

  validateEmail(email) {
    var re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  closeModal(access) {
    let estPreviewData = {
      action: 'preview-close'
    };
    this.templateInfo.action = '';
    this.estimateCallback.emit(estPreviewData);
    switch(access) {
      case 'invoice':
        this.displayModal = false;
        //this.estimatePreviewFlag = false;
        break;
      case 'estimate':
        this.estimateDisplayModal = false;
        //this.estimatePreviewFlag = false;
        break;  
    }
  }

  estimationCallback(data) {
    this.estimationRef = data;
    let field = (this.section == 'estimation' || this.section == 'manage-estimation') ? 'estimate' : 'invoice';
    if(field == 'estimate') {
      this.roData = data.roData;
    }
  }

  estimationEmitCallback(data) {
    console.log(data);    
    let field = (this.section == 'estimation' || this.section == 'manage-estimation') ? 'estimate' : 'invoice';
    let fieldValue = JSON.stringify(data);
    let estimateData = {estimateData: []};
    let estimateInfoDataJsonArr = (this.roData.estimateInfoDataJsonArr && this.roData.estimateInfoDataJsonArr != undefined) ? this.roData.estimateInfoDataJsonArr : [estimateData];
    this.roData.estimateInfoDataJsonArr = estimateInfoDataJsonArr;
    this.roData.estimateInfoDataJsonArr[0].estimateData = data.estimationArray;
    this.roData.estimateInfoDataJsonArr[0].estimationDataJsonArr = data;
    this.estimateData = ((this.estimateData && Array.isArray(this.estimateData) && this.estimateData.length == 0) || this.estimateData == undefined) ? [estimateData] : this.estimateData;
    if(field == 'estimate') {
      this.estimateData[0].estimateData = data.estimationArray;
      this.roData.estimationData = data;
      this.estimateItemEmpty = false;
    } else {
      this.estimateData[0].invoiceData = data.estimationArray;
      this.roData.invoiceData = data;
      this.invoiceItemEmpty = false;
    }    
    this.templateInfo.roData = this.roData;
    this.estimateAction(field, fieldValue, data);
    setTimeout(() => {
      if(field == 'invoice' && this.paymentMethodEnabledFlag){      
        this.roInvoiceRef.estimateActionType = this.estimateActionType;
        //this.roInvoiceRef.estimationTotal = data.estimationTotal;
        //this.roInvoiceRef.wdestimationTotal = data.wdestimationTotal != undefined && data.wdestimationTotal != '' && data.wdestimationTotal != 0  ? data.wdestimationTotal : data.estimationTotal ;
        this.roInvoiceRef.estimationTotal = this.apiUrl.totalPayInvoice;
        this.roInvoiceRef.wdestimationTotal = this.apiUrl.wdTotalPayInvoice;
        this.roInvoiceRef.estimateActionChange();
      }
    }, 1);    

  }

  copyLink(value){
    navigator.clipboard.writeText(value);
    this.copiedModal = true;
    setTimeout(() => {
      this.copiedModal = false;
    }, 1200);    
  }

  changeEstimateType() {
    console.log(this.estimateActionType)
    switch(this.estimateActionType) {
      case 'retail':
        this.estimateActionType = 'wd';        
        break;
      case 'wd':
        this.estimateActionType = 'retail';
        break;
    }
    this.estimationRef.setupDiscountTotal();
    if((this.section == 'invoice' || this.section == 'manage-invoice') && this.paymentMethodEnabledFlag){     
      if(this.roInvoiceRef.estimateActionType) {
        this.roInvoiceRef.estimateActionType = this.estimateActionType;
      }
      //this.roInvoiceRef.estimationTotal = this.roData.invoiceData.estimationTotal;
      //this.roInvoiceRef.wdestimationTotal = this.roData.invoiceData.wdestimationTotal != undefined && this.roData.invoiceData.wdestimationTotal != '' && this.roData.invoiceData.wdestimationTotal != 0  ? this.roData.invoiceData.wdestimationTotal : this.roData.invoiceData.estimationTotal ;
      this.roInvoiceRef.estimationTotal = this.apiUrl.totalPayInvoice;
      this.roInvoiceRef.wdestimationTotal = this.apiUrl.wdTotalPayInvoice;
      this.roInvoiceRef.estimateActionChange();
    }
    //this.estimationRef.setupHeaderColumn();
  }

  navWebsite(url) {
    window.open(url, url);
  }

  navPreview() {
    let aurl = this.previewUrl;
    let navPreviewPdf = window.open(aurl, aurl);
    navPreviewPdf.focus();
  }

  loadROInvoice(){    
    if(this.roInvoiceRef) {
      console.log(this.roData);   
      this.roInvoiceRef.paymentInfoJsonArr = this.roData.paymentInfoJsonArr != undefined ? this.roData.paymentInfoJsonArr : [];
      this.roInvoiceRef.stripeInfoJsonArr = this.roData.stripeInfoJsonArr != undefined ? this.roData.stripeInfoJsonArr : [];  
      this.roInvoiceRef.estimateActionType = this.estimateActionType;
      
      //this.roInvoiceRef.estimationTotal = this.roData.invoiceData.estimationTotal;
      //this.roInvoiceRef.wdestimationTotal = this.roData.invoiceData.wdestimationTotal != undefined && this.roData.invoiceData.wdestimationTotal != '' && this.roData.invoiceData.wdestimationTotal != 0  ? this.roData.invoiceData.wdestimationTotal : this.roData.invoiceData.estimationTotal; 
      
      this.roInvoiceRef.estimationTotal = this.apiUrl.totalPayInvoice;
      this.roInvoiceRef.wdestimationTotal = this.apiUrl.wdTotalPayInvoice;

      this.roInvoiceRef.estimateId = this.estimateInfo != undefined ? this.estimateInfo.estimateId : this.estimateId;     
      this.roInvoiceRef.invoiceID = this.estimateInfo != undefined ? this.estimateInfo.invoiceId : this.invoiceId;    
      this.roInvoiceRef.loadPage();
    }
  }
  roInvoiceCallback(data) {
    console.log(data);
    //this.lastUplodDate = this.roInvoiceRef.lastUplodDate;
  }
  roInvoiceECallback(data) {
    console.log(data);
    if(data && data['action'] == 'empty'){
      this.templateInfo.paymentMethodFlag = true;    
      this.invoiceTemplateFlag = false;
      this.invoiceTemplateFlag = true;
    }
    else{ 
      this.templateInfo.paidStatus = data['paymentStatus'];
      this.templateInfo.invoiceType = data['invoiceType'];
      this.templateInfo.paymentMethodFlag = true;    
      this.invoiceTemplateFlag = false;
      this.invoiceTemplateFlag = true;
    }

    //this.lastUplodDate = this.roInvoiceRef.lastUplodDate;
  }
  roPayStatusCallback(data) {
    if(data && data['action'] == 'payment-status'){
      this.payAfterCallback.emit(data);
    }
  }

  roEstimationApproveActionEmit(event) {
    this.roEstimateListApprove.emit(event);
  }

  adasReportCheck(event) {
    this.adasReportChecked = event.target.checked;
  }

  setupAdasReportCheckBox() {
    this.adasReportChecked = (this.adasReportId > 0 || this.adasThirdPartyReportId > 0) ? true : false;
  }
}
